var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1297_35673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12C18.13 12 15 15.13 15 19C15 20.74 15.5 22.37 16.41 23.84C17.36 25.38 18.61 26.7 19.57 28.24C20.04 28.99 20.38 29.69 20.74 30.5C21 31.05 21.21 32 22 32C22.79 32 23 31.05 23.25 30.5C23.62 29.69 23.95 28.99 24.42 28.24C25.38 26.71 26.63 25.39 27.58 23.84C28.5 22.37 29 20.74 29 19C29 15.13 25.87 12 22 12ZM22 21.75C20.62 21.75 19.5 20.63 19.5 19.25C19.5 17.87 20.62 16.75 22 16.75C23.38 16.75 24.5 17.87 24.5 19.25C24.5 20.63 23.38 21.75 22 21.75Z",
    fill: "#307FE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1297_35673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSymbol);
export default __webpack_public_path__ + "static/media/location_symbol.fe23f9e22fd2f29854d5f5b42fa91f8a.svg";
export { ForwardRef as ReactComponent };